import { OrderError, Order, OrderErrorsResponse } from 'app/orders/order.model';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { ButtonTypes } from 'app/ui/button/button.component';
import { UIDialogData } from 'app/ui/dialog/dialog-injector';
import { OrderService } from 'app/orders/order.service';

// Компонент отображающий ошибки тасок
@Component({
  selector: 'order-errors',
  templateUrl: './order-errors.component.html',
  styleUrls: ['./order-errors.component.scss']
})
export class OrderErrorsComponent implements OnInit {

  constructor(
    @Inject(UIDialogData)
    public order: Order,
    private _dialogService: UIDialogService,
    private _orderService: OrderService
  ) { }

  buttonTypes = ButtonTypes;

  // Список ошибок таски(order)
  errors: OrderError[] | null = null;

  // Текст тултипа
  tooltipText: string = '';

  SUCCESSFUL_COPY = 'The log is copied';

  serverError: string = '';

  ngOnInit() {
    this._orderService.getError(this.order.id, this.order.application)
      .subscribe((response: OrderErrorsResponse) => {
        this.errors = response.errors;
      }, err => {
        this.serverError = `Server Error: ${err.status} ${err.statusText}`;
      });
  }

  showNoErrors() {
    return this.errors && this.errors.length === 0 && this.errors !== null && !this.showServerError();
  }

  showSpinner() {
    return this.errors === null && !this.showServerError();
  }

  showServerError() {
    return this.serverError;
  }

  // Получение строки с датой и временем.
  getDate(date: Date) {
      const tzoffset = (new Date()).getTimezoneOffset() * 60000;
      const ISOString = new Date(date.getTime() - tzoffset).toISOString().split('T');
      const fullDate = ISOString[0];
      const fullTime = ISOString[1].split('.')[0];
      return `${fullDate}, ${fullTime}`;
  }

  // Обработчик закрытия модального окна
  close() {
    this._dialogService.close();
  }

  // Обработчик копирования лога
  copyLog() {
    if (!this.errors || !this.errors.length) {
      return;
    }

    const textArea= document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.left = '0';
    textArea.style.top = '0';
    textArea.style.opacity = '0';
    textArea.value = this.getErrorsLog(this.errors);
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    this.tooltipText = this.SUCCESSFUL_COPY;
    setTimeout(() => {
      this.tooltipText = '';
    }, 2000);
  }

  getErrorsLog(errors: OrderError[]): string {
    let log = '';
    for (const error of this.errors) {
      log += `${error.date.toISOString()}: ${error.description.replace(/\n|\r/g, "")}\n`;
    }

    return log;
  }

}
